var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"like",staticClass:"c-like icobutton"},[_c('i',{ref:"icon",staticClass:"download iconfont iconaixin"})])}
var staticRenderFns = []

export { render, staticRenderFns }